// VUEX MUTATIONS

const mutations = {
  setDepartments: (state, payload) => {
    state.departments = payload;
  },
  updateProgress: (state, payload) => {
    if (payload.total) {
      state.progress.total = payload.total;
    }
    state.progress.current = payload.current;
  },
  AuthorityLogin:(state,payload)=>{
     state.authenticated = payload 
  },
  AuthorityMasterUser:(state,payload)=>{
    state.master_user = payload 
  },
  SaveInfoUser:(state,payload)=>{
     state.user_data = payload
  },
  ResetState:(state,payload)=>{
    state.authenticated = false,
    state.master_user = false,
    state.company_select = 0
    state.user_data = {},
    state.company_list = []
    state.company_select = "",
    state.departament_select = "",
    state.temp_labels = ""
  },
  SaveTempData:(state,payload)=>{
     state.temp_data = payload
  },
  SetCompanySelect:(state,payload)=>{
    state.company_select = payload
  },
  SetDepartamentSelect:(state,payload)=>{
    state.departament_select = payload
  },
  SaveTempLabel:(state,payload)=>{
    state.temp_labels = Object.assign(state.temp_labels,payload)
  },
  UpdateNotificationList:(state,payload)=>{
      state.notification_list.push(payload);
  },
  removeNotification:(state, payload)=>{
    state.notification_list = state.notification_list.filter(notification => notification.id !== payload.id);
  },
  clearNotificationList:(state)=>{
    state.notification_list = [];
  },
  readNotification:(state, notificationId)=>{
    state.notification_list = state.notification_list?.map(notification => {
      if (notification?.id === notificationId) {
        return {...notification, read: true};
      }
      return notification;
    });
  },
  SetCompanyList:(state,payload)=>{
     state.company_list = payload
  },
  SetIdTotemCompany:(state,payload)=>{
    state.id_totem_company_select = payload
  },
  SetTotalCompanys:(state,payload)=>{
    state.total_company_select = payload
  },
  SetIdUserPermission:(state,payload)=>{
   state.temp_id_user_permission=payload
  }
};

export default mutations;
